module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-error-alert"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.message)),
      expression: "localeFtc(message)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee4cf446"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errorAlert.vue
// module id = 746
// module chunks = 0